/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AgentsSetupState, AgentTask, AgentTaskStatus, ConversationsIssuesCluster, List } from "./data-contracts";

/**
 * No description
 * @tags agents
 * @name GetConversationsIssuesCluster
 * @summary Get a conversations issues cluster by its identifier
 * @request GET:/orgs/{organizationId}/conversations-clusters/{clusterId}
 * @secure
 */

// @ts-ignore
export const getConversationsIssuesCluster: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the cluster */
    clusterId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ConversationsIssuesCluster;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations-clusters/{clusterId}",
  method: "get",
  streaming: false,
  tags: ["agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Get the state of the agent.
 * @tags agents, critical
 * @name GetAgentSetupState
 * @summary Get the agents setup state
 * @request GET:/orgs/{organizationId}/agents-setup
 * @secure
 */

// @ts-ignore
export const getAgentSetupState: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AgentsSetupState;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agents-setup",
  method: "get",
  streaming: false,
  tags: ["agents", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags agents
 * @name ListAgentTasks
 * @summary List agent tasks
 * @request GET:/orgs/{organizationId}/agent-tasks
 * @secure
 */

// @ts-ignore
export const listAgentTasks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** The ID of the conversations issues cluster to filter the agent tasks by */
    cluster?: string;
    /** The ID of the space to filter the agent tasks by */
    space?: string;
    /** The statuses of the agent tasks to filter by */
    status?: AgentTaskStatus[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: AgentTask[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/agent-tasks",
  method: "get",
  streaming: false,
  tags: ["agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags agents
 * @name GetAgentTask
 * @summary Get an agent task by its identifier
 * @request GET:/orgs/{organizationId}/agent-tasks/{agentTaskId}
 * @secure
 */

// @ts-ignore
export const getAgentTask: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the agent task */
    agentTaskId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AgentTask;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/agent-tasks/{agentTaskId}",
  method: "get",
  streaming: false,
  tags: ["agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags agents
 * @name UpdateAgentTask
 * @summary Update an agent task by its identifier
 * @request PATCH:/orgs/{organizationId}/agent-tasks/{agentTaskId}
 * @secure
 */

// @ts-ignore
export const updateAgentTask: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the agent task */
    agentTaskId: string;
  };
  RequestQuery: {};
  RequestBody: {
    status: "backlog" | "started" | "canceled";
  };
  RequestHeaders: {};
  ResponseBody: AgentTask;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent-tasks/{agentTaskId}",
  method: "patch",
  streaming: false,
  tags: ["agents"],
  criticalityLevel: "low",
  deprecated: false,
};
